import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export interface BillingInfo {
  plan_type: "starter" | "professional" | "enterprise";
  status: "active" | "suspended" | "cancelled" | "trial";
  plan_started_at: string | null;
  plan_expires_at: string | null;
  business_count: number;
  user_count: number;
}

export function useBilling({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["billing"],
    queryFn: () => api.get<BillingInfo>("/core/me/billing"),
    enabled,
  });
}
